import React, { VFC } from 'react';
import { Inducer } from 'src/components';
import { GatsbyLinkButton } from 'src/components/common/molecules';
import { CategoryLabel, CategoryContainer, CategoryTopImage } from '../';

import Contents from './contents';

const Component: VFC = () => (
  <>
    <Inducer from='#fff' to='var(--color-primary-light)' />
    <CategoryContainer color='var(--color-primary-light)'>
      <CategoryTopImage filename='gummy-programming.svg' size={22} />
      <CategoryLabel label='Projects' color='#fff' />
      <Contents />
      <GatsbyLinkButton to='/projects/' title='DETAILS' />
    </CategoryContainer>
  </>
);

export default Component;
